import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
// v0.18.84 (辉哥 10/25 01:1x 新口径) — 「下拉菜单要用 flarum 原生的 dropdown」。
//   ⇒ 「卡种」从 `<select>` 换成 Flarum 原生 `Dropdown` (⛔ 不是手搓的下拉)。
//   ⚠️ Flarum 的 `Dropdown` 手机端会自动变**底部抽屉** (fixed / 70vh / 上滑 / backdrop),
//      还自带键盘导航、点外关闭、越界翻转 —— 手搓这些一个都没有。
import Dropdown from 'flarum/common/components/Dropdown';
import Api from '../utils/Api';
// v0.18.92 — iOS 上「弹层内容划不动」的修复 (⛔ 只截断 touchmove **传播**, 不改布局)。
//   根因: Flarum core 的 `body-scroll-lock` 在 iOS 分支用 **`.ModalManager` 自己**的
//   scrollTop/scrollHeight 判边界, 而本弹层的真滚动容器是嵌套的 `.Modal-body`
//   ⇒ `.Modal-content` 满屏 ⇒ 两个 preventDefault 分支双向全中 ⇒ 滑动被完全 cancel。
//   修法: 在 `.Modal-content` 上装一个 iOS-only 的 touchmove 监听, 只 `e.stopPropagation()`。
//   详见 `js/src/forum/utils/ModalTouchScroll.js` 的注释 (那里写清了取证与取舍)。
import installModalTouchScroll from '../utils/ModalTouchScroll';
// v0.18.84 (辉哥 10/25 01:1x 新口径) — 「『经办人』用之前做的搜索下拉框方法来做」。
//   ⇒ 用**本仓已有的**「可搜索用户单选」公用组件 (v0.16.7 抽出来的),
//      ⛔ 不许再造第二套 (组件自己有注释写明: 新增同类下拉必须复用, 否则下一轮回归要测两遍)。
import SearchableUserPicker from '../utils/SearchableUserPicker';
// v0.18.94 (辉哥 10/25 14:36 拍板) — 「过期时间」日期选择器 = **本仓公用 helper**
//   (约课 modal `LessonEditorModal.js` 同款) ⇒ ⛔ **不许**新写 `window.flatpickr(...)` 直调。
//   ⚠️ `BindCardModal.js` 那个直调是**老写法**, 新代码不许照抄它。
import { mountDatePicker } from '../utils/DatePickerHelper';
// v0.18.94 — 「默认过期时间 = 今天 + 1 年」公用算法 (跟绑卡 modal 共用一份, ⛔ 不抄第二遍)
import { defaultExpiresAt, defaultExpiresAtDate } from '../utils/DefaultExpiry';
// v0.19.20 (批 41 · 段②) — 「分区骨架」/「字段图标」/「错误文案」三个表单原语**共用一个入口**
//   (本仓铁律「一个逻辑一个入口, 不许抄两遍」; 改前这三个原语在本文件里各抄了一份)。
//   ⚠️ 本文件是**条件渲染**那一份 (`caption` 传 `null` 时不渲染 `.c` 那个 span)
//     ⇒ 调用处一律传 `{ conditionalCaption: true }`。
//   ⚠️ 共用入口在 `utils/FormPrimitives.js` —— 本文件的 DOM 结构与样式**一字不动**。
import { renderSection, fieldIcon, errText } from '../utils/FormPrimitives';
// v0.19.22 (批 43) — 「当前时间」/「flatpickr 挂载销毁」两个动作**共用一个入口**
//   (本仓铁律「一个逻辑一个入口, 不许抄两遍」; 改前本文件与「约课」modal 各抄了一份)。
import { nowFormatted } from '../utils/NowFormatted';
import { retryDatePickerIfNeeded, destroyDatePicker } from '../utils/DatePickerState';

/**
 * ConvertStudentModal — 「转学员 · 办卡」弹层 (v0.18.69, 辉哥 10/23 拍板)
 *
 * ## v0.18.85 (辉哥 10/25 01:1x) —— **整块排版对齐「约课」modal**
 *
 *   视觉基线 (唯一权威): `js/src/forum/modal/LessonEditorModal.js` (约课 modal)。
 *   ⇒ 容器 / 表单行 / 分区 / 底部动作区 **全部照抄**它的词汇, ⛔ 不自创一套 `ZSC-*` 版式。
 *
 *   | 维度 | 约课 modal (照抄) |
 *   |---|---|
 *   | 容器 | `Modal--medium ZS-BookingModal` |
 *   | 表单行 | `ZS-form-row` / `ZS-form-row full` / `ZS-form-group` |
 *   | 标签/输入 | `ZS-form-label` / `ZS-form-input` |
 *   | 分区 | `ZS-section` / `ZS-section-head` / `ZS-section-body` |
 *   | 主体/底部 | `Modal-body` / `Modal-footer` + `Button Button--primary` |
 *
 *   ⛔ 本批**只删 UI**: 后端 `handleTrialCards()` / `bindTrialLessonsToStudent()`
 *      (v0.18.82 加的) **一个字不许动** —— 体验卡仍要绑给新学员、课次 student_id 仍要回填。
 *      验收是**反向验证** (转学员后查库), 不是看 UI 上还有没有那两段。
 *
 * ## 本批 7 项
 *   改 1 排版对齐「约课」modal · 改 2 全部下拉用 Flarum 原生 `Dropdown`
 *   改 3 「经办人」用 `SearchableUserPicker` (可搜 + 拿得到 id/角色)
 *   改 4 登录名**实时**查有效性 + 右侧标记 + 去掉「自动生成」chip
 *   改 5 手机号**必填** · 改 6 去掉「体验卡处理」「本次操作」两段 (⛔ 只删 UI)
 *   改 7 初始密码 (前端生成 / 可改 / 提交后回显给员工)
 *
 * ## ⛔ 三条不可动的口径
 *   ① **前端不许传 `agents[]`** —— `agents` 由**服务端**组装; 本组件只传
 *      `agent_id` + `agent_type`。
 *   ② **前端不许传 `school_id`** 的自由值 —— 校区由**当前校区**锁定 (只读)。
 *   ③ **「已消课」是课次的状态, 不是卡的状态** —— ⛔ 文案里不许出现
 *      「卡已结束」「卡已用完」。
 *
 * ## v0.18.84 (P2-1 / P2-2 / P2-9) 的成果**继续有效**
 *   · 卡种默认值 = 第一个**名称不含「测试」**的卡种
 *   · 经办人默认值 = **跟进记录的经办人**; 该人不在候选里 ⇒ 显示空/占位,
 *     ⛔ 不许静默落到第一项
 *   · ⛔ 界面不许再出现「策略待确认 / 见 S6 / 待辉哥拍板」这类内部字样
 */

/** 阶段标签 (与 SalesTab.formatStage 同口径 —— 存的是英文 key, 显示的是中文) */
const STAGE_LABEL = {
  potential: '潜在客户',
  contacted: '已联系',
  booked: '已约课',
  trial: '已试课',
  closed: '已成交',
  no_intent: '无意向'
};

/**
 * v0.18.85 (改 7) — 生成一个**可读**的临时初始密码
 *
 * ## 为什么在前端生成 (而不是让后端随机)
 *   员工要**当面**把「登录名 + 初始密码」转告客户 ⇒ 这串密码员工**必须看得见**。
 *   后端 `Str::random(20)` 是给程序员看的 (无元音、无易混字符), 念给客户会出事故。
 *   ⇒ 前端生成一份**有元音、无易混字符 (0/O/1/l/I)** 的 10 位密码, **回填进输入框**,
 *     员工看得见、改得动、念得准。
 *
 * ## 规则
 *   · 10 位 (8~12 区间的中位)
 *   · **必含**小写 + 大写 + 数字 (各至少一个) ⇒ 强度不靠随机长度碰运气
 *   · ⛔ 不含 `0 O 1 l I` 等易混字符 (念/写/记的时候最容易错)
 *
 * ## ⛔ 不许把它当安全边界
 *   这串密码是**给人看的**, 不是用来扛爆破的 —— 真要改强度, 改的是后端那条
 *   `Str::random(20)` 兜底路径, ⛔ 不在本批范围。
 */
function generateTempPassword() {
  const lower = 'abcdefghijkmnpqrstuvwxyz'; // ⛔ 去掉 l
  const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // ⛔ 去掉 I / O
  const digit = '23456789'; // ⛔ 去掉 0 / 1
  const all = lower + upper + digit;
  const pick = s => s[Math.floor(Math.random() * s.length)];

  // 先各取一个, 保证三类都出现
  let out = pick(lower) + pick(upper) + pick(digit);
  while (out.length < 10) out += pick(all);

  // 洗牌 (免得「小写小写小写大写数字…」永远按同一顺序开头)
  const arr = out.split('');
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
  }
  return arr.join('');
}
export default class ConvertStudentModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.followup = vnode.attrs.followup || {};
    this.activeSchoolId = vnode.attrs.activeSchoolId || null;
    this.schools = vnode.attrs.schools || [];
    this.onConverted = vnode.attrs.onConverted;

    // ── 表单初值 (设计稿 S2) ────────────────────────────────────────────
    //   登录名默认 `sf{跟进id}` (辉哥清单第 5 项); 邮箱默认 `{username}@ziven.local`
    //   (A 方案, 辉哥 10/23 拍板) —— ⛔ 但**允许手改**。
    const username = 'sf' + this.followup.id;
    this.form = {
      username: username,
      nickname: (this.followup.customer_name || '').trim(),
      phone: (this.followup.phone || '').trim(),
      email: username + '@ziven.local',
      template_id: null,
      agent_id: this.followup.sales_id || null,
      is_activated: true,
      // v0.18.94 (改 5, 辉哥 10/25 14:36 拍板) — 过期时间 **默认 = 今天 + 1 年**
      //   ⚠️ 2/29 边界由 `DefaultExpiry.defaultExpiresAt()` 处理 (2028-02-29 ⇒ 2029-02-28)。
      //   ⛔ **不支持永不过期** ⇒ 开关打开时这一项必填 (前端 canSubmit + 后端 422 双保险)。
      expires_at: defaultExpiresAt(),
      // v0.18.94 — 开卡时间 (开关打开的时刻) —— 「开卡时间将记录为」那句提示用
      activated_at: null,
      // v0.18.85 (改 7) — 初始密码: **前端**生成一份并回填 (员工看得见、改得动)。
      //   ⛔ 提交时带给后端 (后端 `StudentFactory::createOrReuse()` 已支持 `$attrs['password']`)。
      password: generateTempPassword()
    };
    // v0.18.94 — 开关**默认是开的** ⇒ 「开卡时间」从弹层打开那一刻起算
    //   (跟绑卡 modal 的 `nowFormatted()` 同一口径)。
    if (this.form.is_activated) {
      this.form.activated_at = nowFormatted();
    }
    // ⛔ 邮箱**手改过**就不再跟着登录名自动重算 (否则用户白改了)。
    this.emailTouched = false;
    this.templates = [];
    this.loading = true;
    this.saving = false;
    this.error = '';
    // v0.18.84 (P2-2) — 「跟进的经办人**不在**当前校区候选里」的标记。
    //   true ⇒ 经办人保持 null (让用户**显式**选) + UI 上给一句人话说明。
    //   ⛔ 不再静默回落到候选列表**第一个人** —— 那会把「跟进的经办人不在候选里」
    //      这件事**伪装成**「系统已经替你选好了」。
    this.agentMissing = false;

    // ── v0.18.85 (改 4) — 「登录名能不能用」的实时校验状态 ──────────────────
    //   status: 'idle' (没输入 / 不显示任何标记) | 'checking' (轻量加载态)
    //           | 'ok' | 'taken' | 'format' | 'error'
    //   ⚠️ **空值 ⇒ 'idle' ⇒ 界面上一个标记都不显示** (⛔ 不许一上来就飘红)。
    //   timer: 防抖定时器 (⛔ 每敲一个键就发请求 = 自己打自己)
    //   seq:   竞态守卫 —— 只有**最后一次**请求的结果算数 (⛔ 过期响应必须丢弃)
    this.usernameCheck = {
      status: 'idle',
      timer: null,
      seq: 0
    };
    // 登录名**已被占用** ⇒ 会复用已有账号 ⇒ ⛔ 不许给已有账号改密码 ⇒ 密码字段禁用
    this.usernameTaken = false;
    // 「显示初始密码」开关 (⛔ 默认**不**明文展示)
    this.showPassword = false;
    // 改 7 — 提交成功后的结果提示 (⛔ 只在内存里, ⛔ 不持久化到 localStorage)
    this.result = null;

    // v0.18.84 (P2-2 + 辉哥 10/25 01:1x 新口径) — 「经办人」用**可搜索用户单选**组件。
    //   · 候选来源与改前**完全一致**: GET /users?role=coach,sales&school_id=N
    //     (组件自己拉, ⛔ 本 modal 不再重复拉一遍 —— 改前是本 modal 拉的)。
    //   · `bare: true` —— 宿主(这个弹层)自己已经有「经办人」标签了, 不套组件的外壳,
    //     否则会出现**两个**标签 (组件自己的注释里写明了这条: bare = 只输出 .ZS-agent-search)。
    //   · ⛔ 组件**没有**「默认选中第一个人」这种回落: 选中值对不上候选就是**空**的,
    //     所以改 2 的「不在候选里 ⇒ 留空」由组件天然满足。
    this.picker = new SearchableUserPicker({
      host: this,
      getSchoolId: () => this.activeSchoolId,
      getValue: key => this.form[key],
      setValue: (key, v) => {
        this.form[key] = v;
      },
      fields: {
        agent_id: {
          role: 'coach,sales',
          bare: true,
          placeholder: '输入姓名筛选…',
          emptyText: '当前校区下没有匹配的候选人'
        }
      }
    });

    // ── v0.18.94 — flatpickr 的**生命周期状态机** (照抄「约课」modal 的 `_dp`)
    //   ⚠️ 为什么必须是状态机而不是「每次 redraw 都 init」:
    //     · flatpickr 是**异步 vendor 资源** (ziven-core 提供, XHR 加载) ⇒ 挂载要等;
    //     · 开关一关一开 ⇒ 日期框是**新的 DOM 节点** ⇒ 旧实例必须先销毁;
    //     · 不 destroy 的话, document.body 上会留一个孤儿 `.flatpickr-calendar`。
    this._dp = {
      instance: null,
      el: null,
      mounting: false,
      wantEl: null,
      failedEl: null
    };
    this.load();
  }

  // ── 可搜索用户单选组件的生命周期 (与 FixedLessonModal / SalesFollowupCreateModal 同款) ──
  oncreate(vnode) {
    super.oncreate(vnode);
    this.picker.mount();
    // v0.18.92 — 给本弹层的 `.Modal-content` 装 iOS 触摸滚动修复
    this.installTouchScroll();
    // v0.18.94 — 首帧就把「过期时间」日期框挂上 flatpickr (与「约课」modal 同款)
    this.ensureDatePicker();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.picker.afterUpdate();
    // v0.18.92 — **防御性**补装: 万一 `.Modal-content` 换了一个实例
    //   (Mithril 理论上不会, 但结果面板分支会换 `.Modal-body` ⇒ 顺手防一手)
    //   ⇒ 给新元素再装一次; `installModalTouchScroll` 的幂等保证不会重复装。
    const el = this.element ? this.element.querySelector('.Modal-content') : null;
    if (el && el !== this.touchScrollEl) {
      this.touchScrollEl = el;
      installModalTouchScroll(el);
    }
    // v0.18.94 — 「开卡」开关一关一开 ⇒ 日期框是**新节点** ⇒ 这里负责把 flatpickr
    //   从旧节点挪到新节点 (幂等: 已经绑在当前节点上就直接返回)。
    this.ensureDatePicker();
  }

  /**
   * v0.18.92 — 找到本弹层的 `.Modal-content` 并装上 iOS 触摸滚动修复
   *
   * ## 元素来源
   *   `this.element` = 本 modal 的根 DOM = `.Modal` div (Flarum `Modal.view()` 渲染的
   *   `<div className="Modal modal-dialog fade …">`), `.Modal-content` 是它的**直接子节点**。
   *
   * ## 找不到怎么办
   *   ⛔ **不许抛** (抛异常会把整个 modal 弄挂) ⇒ 静默 no-op;
   *   极少见的情况下 (`.Modal-content` 还没渲染出来) 用 `requestAnimationFrame`
   *   **重试一次**, 仍拿不到就放弃 (⛔ 不许无限重试)。
   */
  installTouchScroll() {
    const el = this.element ? this.element.querySelector('.Modal-content') : null;
    if (el) {
      this.touchScrollEl = el;
      installModalTouchScroll(el);
      return;
    }
    // 已经排过一次队 ⇒ 不重复排
    if (this.touchScrollRetryQueued) return;
    this.touchScrollRetryQueued = true;
    if (typeof requestAnimationFrame !== 'function') return;
    requestAnimationFrame(() => {
      this.touchScrollRetryQueued = false;
      // ⚠️ 弹层可能已经被关掉了 ⇒ `this.element` 为空 ⇒ 静默放弃
      const el2 = this.element ? this.element.querySelector('.Modal-content') : null;
      if (!el2) return;
      this.touchScrollEl = el2;
      installModalTouchScroll(el2);
    });
  }

  // ─────────────────────────────────────────────────────────────────────
  // v0.18.94 — 「过期时间」日期选择器 (flatpickr)
  //
  // ⛔ **生命周期照抄「约课」modal** (`LessonEditorModal.js` 的 `_dp` 状态机):
  //   · 挂载是**异步**的 (helper 内部要等 vendor flatpickr 加载完) ⇒ 必须防重复挂载;
  //   · 开关一关一开 ⇒ 日期框是**新 DOM 节点** ⇒ 旧实例必须先销毁再挂新的;
  //   · 弹层关闭 (`onremove`) ⇒ 销毁实例 (⛔ 否则 document.body 上留孤儿 calendar)。
  // ─────────────────────────────────────────────────────────────────────

  /**
   * 幂等挂载 flatpickr (跟「约课」modal 的 `ensureDatePicker()` 同款)
   *
   * 调用点: oncreate (首帧) + onupdate (每次 patch 后)。
   */
  ensureDatePicker() {
    const dp = this._dp;
    // 开关关着 ⇒ 整段过期时间**不渲染** ⇒ 没有日期框可挂 (也保证关着时 DOM 里一个 flatpickr 都没有)
    if (!this.form.is_activated) {
      dp.wantEl = null;
      if (dp.instance) destroyDatePicker(this._dp);
      return;
    }
    const el = this.element ? this.element.querySelector('.ZS-flatpickr-input') : null;
    if (!el) {
      // 输入框不在了 (开关关了 / modal 正在拆) ⇒ 把旧实例销毁, 免得留个孤儿 calendar
      dp.wantEl = null;
      if (dp.instance) destroyDatePicker(this._dp);
      return;
    }
    dp.wantEl = el;
    // 已经绑在当前这个 input 上且它还在 DOM 里 ⇒ 已经是想要的状态, 什么都不做
    if (dp.instance && dp.el === el && el.isConnected) return;
    // 实例还绑在旧的/别的节点上 ⇒ 先销毁, 避免两个实例抢同一个输入框
    if (dp.instance) destroyDatePicker(this._dp);
    // 同一个节点挂不上 (vendor 没就绪) ⇒ 不重复试 (否则每次 redraw 都白等 5s)
    if (dp.failedEl === el) return;
    // 已有一次在途挂载 ⇒ 等它结束 (结束时会按 wantEl 自动复查)
    if (dp.mounting) return;
    this.mountDatePickerOn(el);
  }

  /** 真正去挂 (异步: `mountDatePicker` 内部要等 vendor) */
  async mountDatePickerOn(el) {
    const dp = this._dp;
    dp.mounting = true;
    let instance = null;
    try {
      instance = await mountDatePicker(el, {
        mode: 'date',
        // v0.18.94 — 显式钉死 `Y-m-d` (helper 默认是 `Y/m/d`)
        //   ⇒ flatpickr 写进 input 的值 == 我们提交/显示的值 == 落库的日期, 逐字一致。
        dateFormat: 'Y-m-d',
        // 日历打开时定位到当前值 (默认 = 今天 + 1 年)
        defaultDate: this.dateFromIso(this.form.expires_at),
        // ⛔ **不传** `minDate: 'today'` —— 内部员工可能要**补录过去**的卡
        //   (跟「约课」modal 的注释同一条理由)。
        onChange: (selectedDates, dateStr) => {
          // ⛔ 清空时 flatpickr 给的是空串 ⇒ 这一项变成「没选」⇒ 主按钮被 canSubmit 拦住
          this.form.expires_at = dateStr || '';
          m.redraw();
        }
      });
    } catch (e) {
      console.error('[convert-student] date picker init failed', e);
      instance = null;
    }
    dp.mounting = false;
    if (!instance) {
      // vendor 没就绪 (helper 最多等 5s) ⇒ 记下这个节点, 同一个节点不再重复试
      dp.failedEl = el;
      return;
    }
    // 挂载期间可能开关被关了 / modal 被关了 (节点被摘) ⇒ 这一份作废
    if (!el.isConnected || dp.wantEl !== el) {
      try {
        instance.destroy();
      } catch (e) {/* noop */}
      retryDatePickerIfNeeded(this._dp, () => this.ensureDatePicker());
      return;
    }
    dp.instance = instance;
    dp.el = el;
  }

  /** `'YYYY-MM-DD'` ⇒ **本地零点**的 Date (flatpickr `defaultDate` 用) */
  dateFromIso(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    if (!m) return defaultExpiresAtDate();
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }

  /**
   * v0.18.94 (改 ③/④) — 「开卡」开关
   *
   * ## 口径 (辉哥 10/25 14:36 拍板)
   *   · **打开** ⇒ 显示过期时间 (flatpickr) + 过期时间**必填**;
   *   · **关闭** ⇒ 过期时间整段隐藏 (沿用绑卡 modal 现有行为) + 清空过期时间;
   *   · 打开时若过期时间还是空的 ⇒ **预填「今天 + 1 年」** (改 ⑤)。
   */
  setActivated(on) {
    const next = !!on;
    this.form.is_activated = next;
    if (next) {
      this.form.activated_at = nowFormatted();
      // 改 ⑤ — 默认 1 年 (⚠️ 只在**空**的时候预填 ⇒ 用户自己改过的值不许被冲掉)
      if (!this.form.expires_at) {
        this.form.expires_at = defaultExpiresAt();
      }
    } else {
      this.form.activated_at = null;
      // 沿用绑卡 modal 现有行为: 关掉 ⇒ 过期时间清空 (⛔ 不支持「永不过期」的残留值)
      this.form.expires_at = null;
    }
    m.redraw();
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.picker.destroy();
    // v0.18.94 — flatpickr 必须跟 modal 同生共死:
    //   不 destroy 的话, document.body 上会留一个孤儿 `.flatpickr-calendar`,
    //   而且它的 document 监听 (mousedown/touchstart) 会一直活着。
    destroyDatePicker(this._dp);
    // ⚠️ 防抖定时器必须摘掉 —— 弹层关了再触发一次请求就是「关掉之后还在发请求」。
    if (this.usernameCheck && this.usernameCheck.timer) {
      clearTimeout(this.usernameCheck.timer);
      this.usernameCheck.timer = null;
    }
  }
  className() {
    // v0.18.85 (改 1) — 容器对齐「约课」modal (`Modal--medium ZS-BookingModal`)。
    //
    // ⚠️ **额外保留** `ZS-ConvertStudentModal` 的理由 (⛔ 不是偷懒, 是有依赖):
    //   ① 批 3 在 `less/forum.less` **文件末尾**追加的那段
    //      `.Modal.ZS-ConvertStudentModal { .ZSC-choice-dropdown { … } }`
    //      (卡种下拉撑满 100% + 折行修正 + 选中项高亮) **作用域锁在这个 class 上**
    //      ⇒ 去掉它, 那段样式整段失效 ⇒ 本批**复用**它, ⛔ 不另起一段同名重复规则
    //      (本仓铁律: 一个逻辑一个入口)。
    //   ② 品牌蓝主按钮覆盖 (`.Modal.ZS-ConvertStudentModal .Button--primary`) 同理。
    //   ③ 宽度: `.Modal.ZS-ConvertStudentModal { max-width: 520px }` (既有规则, ⛔ 不许改)。
    // ⇒ 验收口径「容器 class **含** `ZS-BookingModal` + `Modal--medium`」两个都在。
    return 'Modal--medium ZS-BookingModal ZS-ConvertStudentModal';
  }
  title() {
    return m("span", null, m("i", {
      className: "fas fa-user-plus",
      style: "color:var(--zs-brand, #2D7BE5);margin-right:8px;"
    }), "\u8F6C\u5B66\u5458 \xB7 \u529E\u5361");
  }

  // ─────────────────────────────────────────────────────────────────────
  // 加载
  // ─────────────────────────────────────────────────────────────────────

  async load() {
    try {
      const [templates] = await Promise.all([Api.list('card-templates', {
        status: 'enabled'
      }),
      // v0.18.84 (P2-2) — 经办人候选由**可搜索下拉组件**自己拉
      //   (role=coach,sales + 当前校区; 与改前本 modal 自己拉的那次请求**逐字一致**)。
      this.picker.loadAll()]);
      this.templates = templates || [];
      // ── v0.18.84 (P2-1) 卡种默认值 ──────────────────────────────────────
      //   ⚠️ **为什么**要跳过「测试」: 生产库里有一张**内部测试**卡种 (名里带「测试」,
      //      生产那张叫「测试卡」id=21), 它是历史测试数据, 不该出现在**默认值**上 ——
      //      销售容易直接按回车把「测试卡」发给真客户。
      //   ⇒ 默认选中时**跳过**名称里带「测试」的卡种 (取第一个不含「测试」的);
      //      若**所有**卡种都带「测试」⇒ 回落现在的行为 (取 templates[0])。
      //   ⛔ 不许改卡种列表的**顺序**、不许隐藏任何卡种 (这里只挑默认值)。
      if (!this.form.template_id && this.templates.length) {
        const firstReal = this.templates.find(t => !String(t.name || '').includes('测试'));
        this.form.template_id = Number((firstReal || this.templates[0]).id);
      }
      // ── v0.18.84 (P2-2) 经办人默认值 ────────────────────────────────────
      //   ⛔ **删掉**了原来那两行「候选里找不到就退到第一个」的静默回落:
      //        跟进的经办人**不在**候选里时 ⇒ 保持 null (让用户显式选) + UI 说明。
      //   ⚠️ 注意 `followup.sales_id` **确实**是后端返回的 (ListSalesFollowupsController
      //      返 `'sales_id' => (int) $f->sales_id`) —— 这里**不需要**去「修 sales_id 缺失」。
      //   ⚠️ 判据用组件的 `selectedUser()` —— 候选列表里没有这个人 ⇒ 返回 null。
      if (this.form.agent_id && !this.picker.selectedUser('agent_id')) {
        this.form.agent_id = null;
        this.agentMissing = true;
      }
    } catch (e) {
      console.error('convert student load failed', e);
      this.error = errText(e, '加载卡种 / 经办人失败');
    } finally {
      this.loading = false;
      m.redraw();
    }
  }

  /** 后端错误的 `detail` 文案 (⛔ 不自己编文案)
   *  ⚠️ v0.19.20 (批 41 · 段②) — 实现**搬**进共用入口 `utils/FormPrimitives.js`
   *    (改前 `errText` 在本文件里抄了一份 ⇒ 本仓铁律「一个逻辑一个入口」)。 */

  // ─────────────────────────────────────────────────────────────────────
  // 派生数据
  // ─────────────────────────────────────────────────────────────────────

  schoolName() {
    const id = this.activeSchoolId ? Number(this.activeSchoolId) : null;
    const s = this.schools.find(x => Number(x.id) === id);
    return s ? s.name : '—';
  }
  salesName() {
    const s = this.followup.sales;
    if (s && (s.display_name || s.username)) return s.display_name || s.username;
    return this.followup.sales_id ? `销售 #${this.followup.sales_id}` : '—';
  }
  customerName() {
    return (this.followup.customer_name || '').trim() || '—';
  }
  selectedTemplate() {
    return this.templates.find(t => Number(t.id) === Number(this.form.template_id)) || null;
  }
  selectedAgent() {
    return this.picker ? this.picker.selectedUser('agent_id') : null;
  }

  /**
   * 体验卡清单 (⛔ 没有体验卡 ⇒ 空数组 ⇒ 分区④ 整段不渲染)
   *
   * ⚠️ v0.18.87 **恢复** (批 4 / v0.18.85 改 6 把分区④⑤ 删掉时, 这两个派生方法一并删了;
   *   辉哥 10/25 08:1x 「里面绑卡的 section 怎么没了」⇒ 本批原样恢复)。
   *
   * v0.18.74 (D1) — 后端新增 `trial_cards[]` (**逐张**列出);
   *   旧的单数字段 `trial_card` 仍在 (⛔ 不许删, 别的代码路径在用) ⇒ 这里做一次**归一**:
   *   有 `trial_cards[]` 就用它; 没有 (旧后端 / 单卡) 才退回 `trial_card` 退化成的单元素数组。
   */
  trialCards() {
    const list = this.followup.trial_cards;
    if (Array.isArray(list) && list.length) return list;
    const one = this.followup.trial_card;
    return one ? [one] : [];
  }

  /**
   * 体验卡计数 { total, unused, consumed }
   *   ⚠️ 「已消课 / 未体验」的判据 = 每张卡的 `branch` (后端按**课次**状态算的, 口径唯一)。
   *   ⭐ 不变式: `unused + consumed === total`
   */
  trialCardCounts() {
    const cards = this.trialCards();
    let unused = 0;
    let consumed = 0;
    cards.forEach(c => {
      if (c.branch === 'consumed') {
        consumed++;
      } else {
        unused++;
      }
    });
    return {
      total: cards.length,
      unused: unused,
      consumed: consumed
    };
  }

  /** 卡种下拉里每一项的显示文本 (选项与按钮标题**逐字一致**) */
  templateLabel(t) {
    return `${t.name} · ${t.lessons} 课时 · ¥${Number(t.price).toLocaleString()}`;
  }

  /**
   * v0.18.84 (P2-1 + 辉哥 10/25 01:1x 新口径) — 「卡种」下拉 = **Flarum 原生 `Dropdown`**。
   *
   * ## 为什么改控件形态
   *   辉哥 10/25 01:1x: 「转学员办卡 modal 里面的**下拉菜单要用 flarum 原生的 dropdown**」。
   *   ⛔ 不是手搓的下拉 —— Flarum 的 `Dropdown` 手机端会自动变底部抽屉, 还自带
   *      键盘导航 / 点外关闭 / 越界翻转, 手搓这些一个都没有。
   *
   * ## 为什么原来的 `<select>` 会「默认选中列表第一个人」
   *   `<select>` 的 option 列表是**异步后到**的: 第一次渲染时一个 option 都没有,
   *   value 写进去匹配不上任何选项 (selectedIndex = -1); 之后 option 插进来,
   *   浏览器按 HTML 规范「自动选中第一项」, 而 Mithril 不会再补写一次 value
   *   ⇒ 值就此被定死成**列表第一个人** (2026-10-25 生产 vlog 实测)。
   *   换成 `Dropdown` 之后**这个机制不再适用**: 选中态由 `form.template_id` 决定,
   *   标题取「当前值对应的那一项」; 当前值不在列表里 ⇒ 显示**占位文案**,
   *   **不会**静默落到第一项。
   *   ⇒ 「默认值必须在候选列表就绪之后才设对」这个原则不变, 只是载体换了。
   *
   * ## 「默认值怎么保证的」
   *   ① `form.template_id` **只在 load() 里、候选到齐之后**才赋值 (见 load());
   *   ② 标题 = `templates.find(t => t.id === form.template_id)` —— 找不到就是占位文案;
   *   ③ 列表没就绪时 (`this.loading`) 整个下拉都**不渲染**, 只显示「加载中…」。
   *
   * ## v0.18.85 — 外壳跟着「约课」modal 走
   *   `buttonClassName="ZS-form-input"` (约课 modal 同款) + 容器/菜单沿用批 3 的
   *   `ZSC-choice-dropdown` / `ZSC-choice-dropdown-menu` (⛔ 那个 LESS 段的作用域
   *   锁死在这两个 class 上, 改名 = 那段样式失效)。
   */
  renderTemplateDropdown() {
    const current = this.templates.find(t => Number(t.id) === Number(this.form.template_id)) || null;
    const items = this.templates.length ? this.templates.map(t => m(Button, {
      key: t.id,
      active: !!current && Number(current.id) === Number(t.id),
      onclick: () => this.chooseTemplate(t)
    }, this.templateLabel(t))) : [m(Button, {
      key: "__empty",
      disabled: true
    }, "\u6682\u65E0\u53EF\u9009\u9879")];
    return m(Dropdown, {
      className: "ZSC-choice-dropdown",
      buttonClassName: "ZS-form-input",
      menuClassName: "ZSC-choice-dropdown-menu",
      label: current ? this.templateLabel(current) : '— 选择卡种 —',
      lazyDraw: true
    }, items);
  }

  /** 选中卡种 (值存 id; ⛔ 不改列表顺序) */
  chooseTemplate(t) {
    this.form.template_id = Number(t.id);
    // ⚠️ `m` 是全局 (webpack 解析不到 'mithril' 那个包名) ⇒ 兜底判一下,
    //    写法跟 js/src/forum/utils/SearchableUserPicker.js:151 同款。
    if (typeof m !== 'undefined') m.redraw();
  }

  // ─────────────────────────────────────────────────────────────────────
  // v0.18.85 (改 4) — 登录名「能不能用」的实时校验
  // ─────────────────────────────────────────────────────────────────────

  /**
   * 登录名输入变化 ⇒ (重新)排一次有效性检查
   *
   * ## 三条硬约束 (每条都有代价)
   *   ① **防抖** (350ms) —— ⛔ 每敲一个键就发请求 = 自己打自己 (打 8 个字 = 8 个请求)。
   *      350ms 是本仓「实时碰撞预览」那条 (v0.17.75) 用的同一个量级。
   *   ② **丢弃过期响应** —— 快速改字时旧请求后到, ⛔ 不许覆盖新结果。
   *      判据 = `seq`: 每次发请求前 `++seq`, 回来时 `seq` 对不上 ⇒ 直接扔掉。
   *   ③ **空值不显示任何标记** —— ⛔ 不许一上来就飘红。
   */
  onUsernameInput(value) {
    this.setField('username', value);
    const v = String(value || '').trim();

    // 取消**还没发出去**的那次检查
    if (this.usernameCheck.timer) {
      clearTimeout(this.usernameCheck.timer);
      this.usernameCheck.timer = null;
    }
    // ⛔ 序号 +1 ⇒ 在途的那个请求回来时会被判成「过期」而丢弃
    this.usernameCheck.seq++;
    if (v === '') {
      this.usernameCheck.status = 'idle';
      this.setUsernameTaken(false);
      m.redraw();
      return;
    }

    // 轻量加载态 (⛔ 不许让输入框闪 —— 所以**不**改输入框本身, 只在右侧加一个标记)
    this.usernameCheck.status = 'checking';
    m.redraw();
    this.usernameCheck.timer = setTimeout(() => {
      this.usernameCheck.timer = null;
      this.runUsernameCheck(v);
    }, 350);
  }

  /** 真去问后端: `GET /students/check-username?username=xxx` */
  async runUsernameCheck(username) {
    const seq = ++this.usernameCheck.seq;
    try {
      const res = await Api.checkUsername(username);
      // ⛔ 过期响应**必须丢弃** (快速改字时旧请求后到)
      if (seq !== this.usernameCheck.seq) return;
      const reason = res && res.reason || 'ok';
      if (reason === 'ok') {
        this.usernameCheck.status = 'ok';
        this.setUsernameTaken(false);
      } else if (reason === 'taken') {
        this.usernameCheck.status = 'taken';
        this.setUsernameTaken(true);
      } else {
        this.usernameCheck.status = 'format';
        this.setUsernameTaken(false);
      }
    } catch (e) {
      if (seq !== this.usernameCheck.seq) return;
      // 查不了就**不拦**提交 (后端提交时还会再校验一次) —— 但要让员工知道「没查成」
      this.usernameCheck.status = 'error';
    }
    m.redraw();
  }

  /**
   * 登录名「已被占用」的联动
   *
   * ⚠️ ⛔ **不许给已有账号改密码** —— 复用已有账号时, 后端 `StudentFactory` 的复用分支
   *    只补 user_school + group_user, 一个字都不碰已有账号的密码。
   *    ⇒ 前端必须**同步**把密码字段禁用 (并清空), 免得员工以为「我设了新密码」。
   */
  setUsernameTaken(taken) {
    if (taken) {
      if (!this.usernameTaken) {
        this.form.password = '';
      }
    } else if (this.usernameTaken) {
      // 从「已被占用」改回可用 ⇒ 密码字段重新可用 ⇒ **重新生成**一份
      // (⛔ 不许留空: 空密码会让后端走 `Str::random(20)` 随机兜底, 员工就看不到密码了)
      this.form.password = generateTempPassword();
    }
    this.usernameTaken = !!taken;
  }

  /** 输入框右侧的「能不能用」标记 (⛔ 空 ⇒ 一个标记都不显示) */
  renderUsernameMarker() {
    const st = this.usernameCheck.status;
    const T = k => app.translator.trans('ziven-scheduler.forum.sales.convert.' + k);
    if (st === 'idle') return null;
    if (st === 'checking') {
      return m("span", {
        className: "ZSC-chip"
      }, T('username-checking'));
    }
    if (st === 'ok') {
      return m("span", {
        className: "ZSC-chip ok"
      }, T('username-ok'));
    }
    if (st === 'taken') {
      return m("span", {
        className: "ZSC-chip err"
      }, T('username-taken'));
    }
    if (st === 'format') {
      return m("span", {
        className: "ZSC-chip warn"
      }, T('username-format'));
    }
    return m("span", {
      className: "ZSC-chip"
    }, T('username-error'));
  }

  // ─────────────────────────────────────────────────────────────────────
  // 交互
  // ─────────────────────────────────────────────────────────────────────

  setField(key, value) {
    this.form[key] = value;
    // 登录名改了 ⇒ 邮箱跟着重算 (⛔ 除非用户手改过邮箱)
    if (key === 'username' && !this.emailTouched) {
      this.form.email = String(value || '').trim() + '@ziven.local';
    }
    if (key === 'email') {
      this.emailTouched = true;
    }
    m.redraw();
  }

  /**
   * v0.18.85 (改 5) — 手机号**必填**
   *
   * ⚠️ 判据只有「空不空」这一条 —— **格式**校验继续走后端 `StudentFactory`
   *    (`/^1[3-9]\d{9}$/`), ⛔ 前端不另写一条格式规则 (两边各写一套必然漂移)。
   */
  phoneMissing() {
    return !this.form.phone || !this.form.phone.trim();
  }
  canSubmit() {
    if (this.saving || this.loading) return false;
    // 卡种列表为空 ⇒ 禁用主按钮 + 给一句人话提示 (⛔ 不静默失败)
    if (!this.templates.length) return false;
    if (!this.form.username || !this.form.username.trim()) return false;
    if (!this.form.nickname || !this.form.nickname.trim()) return false;
    // v0.18.85 (改 5) — 手机号必填
    if (this.phoneMissing()) return false;
    if (!this.form.email || !this.form.email.trim()) return false;
    if (!this.form.template_id) return false;
    if (!this.form.agent_id) return false;
    // v0.18.94 (改 ④, 辉哥 10/25 14:36 拍板) — **过期时间必填**
    //   ⛔ **不支持永不过期** ⇒ 开卡时必须选一个过期日期。
    //   ⚠️ 开关**关着**时不要求 (沿用绑卡 modal 的写法: 那一段整段隐藏)。
    if (this.form.is_activated && !this.form.expires_at) return false;
    return true;
  }
  async submit() {
    if (!this.canSubmit()) return;
    this.saving = true;
    this.error = '';
    m.redraw();
    try {
      const tpl = this.selectedTemplate();
      const agent = this.selectedAgent();
      const attrs = {
        username: this.form.username.trim(),
        nickname: this.form.nickname.trim(),
        phone: this.form.phone.trim(),
        email: this.form.email.trim(),
        school_id: this.activeSchoolId ? Number(this.activeSchoolId) : null,
        template_id: Number(this.form.template_id),
        agent_id: Number(this.form.agent_id),
        // ⛔ `agents[]` **不许**由前端传 (服务端自己组装)
        agent_type: agent && agent.role || 'sales',
        is_activated: !!this.form.is_activated,
        // v0.18.94 (改 ⑤) — 过期时间 **默认 = 今天 + 1 年**, ⛔ 不支持永不过期
        //   ⇒ 开卡时必带 (后端 `requireExpiresWhenActivated=true` 会兜底 422)。
        expires_at: this.form.expires_at || null,
        // v0.18.94 — 开卡时间 (界面那句「开卡时间将记录为」承诺的就是它)
        //   ⚠️ 后端 `$attrs['activated_at'] ?? date('Y-m-d H:i:s')` ⇒ 不传就用提交时刻。
        activated_at: this.form.activated_at || null
      };
      // ── v0.18.85 (改 7) — 初始密码 ────────────────────────────────────────
      //   只在「**新建**账号」时带 (复用已有账号时 ⛔ 不许改人家密码)。
      const reuseExisting = !!this.usernameTaken;
      if (!reuseExisting && this.form.password) {
        attrs.password = this.form.password;
      }
      const res = await Api.convertStudent(this.followup.id, attrs);
      this.saving = false;
      const payload = Object.assign({}, res || {}, {
        // 课时数前端自己知道 (卡种模板) —— 后端响应里没有这一项 (brief §3.2 的字段清单)
        card_lessons: tpl ? Number(tpl.lessons) : 0
      });
      if (this.onConverted) this.onConverted(payload);
      // ── 改 7 — 提交成功后**显示结果提示** (⛔ 只在内存里, ⛔ 不写 localStorage) ──
      //   ⛔ 不再 this.hide(): 员工还没拿到「登录名 + 初始密码」就关掉弹层 = 密码丢了。
      //   ⇒ 换成「结果面板」, 员工点「完成并关闭」才关。
      this.result = {
        username: this.form.username.trim(),
        password: reuseExisting ? '' : this.form.password,
        reused: reuseExisting
      };
      m.redraw();
    } catch (e) {
      this.error = errText(e, '转学员失败');
      this.saving = false;
      m.redraw();
    }
  }

  // ─────────────────────────────────────────────────────────────────────
  // 渲染
  // ─────────────────────────────────────────────────────────────────────

  /**
   * v0.18.85 (改 1) — 分区卡片外壳 (照抄「约课」modal 的 renderSection)
   *
   * ⚠️ v0.18.87 — 加了第 5 个可选参数 `extra` (标题行右侧的附加内容, 如 ④ 的「共 N 张」chip)。
   *   `caption` 为空时**不渲染** `.c` 那个 span (窄屏 `.c` 是 `display:none`,
   *   ④ 的 chip 不能塞进 `.c` 里, 否则手机端就看不见了)。
   *
   * ⚠️ v0.19.20 (批 41 · 段②) — 实现**搬**进共用入口 `utils/FormPrimitives.js`
   *   (改前 `renderSection` / `fieldIcon` 在本文件里各抄了一份 ⇒ 本仓铁律「一个逻辑一个入口」)
   *   ⇒ 本文件的 DOM 结构与样式**一字不动**。
   *   ⇒ 本文件是**条件渲染**那一份 ⇒ 6 处调用**一律**传 `{ conditionalCaption: true }`。
   *   ⇒ `extra` 那个插槽**还在用** (④ 的「共 N 张」chip) ⇒ 走共用入口的 `opts.extra`。
   */

  content() {
    // v0.18.85 (改 7) — 提交成功后的结果提示 (⛔ 一次, ⛔ 不持久化)
    if (this.result) return this.renderResult();
    const f = this.followup;
    // ⚠️ v0.18.87 — 恢复「体验卡处理 / 本次操作」两段 (分区④⑤) 所需的数据源。
    //   ⛔ 后端一个字没改: `trial_cards[]` 字段还在 (`ListSalesFollowupsController.php:355`)。
    const cards = this.trialCards();
    const counts = this.trialCardCounts();

    // ⚠️ v0.18.87 — 分区编号**按实际渲染顺序动态分配** (⛔ 不许写死「④⑤」):
    //   分区④「体验卡处理」是**条件渲染** (没有体验卡 ⇒ 整段不渲染) ⇒
    //   分区⑤「本次操作」必须**顶上去当 ④**, ⛔ 不许出现「④ 不出现但 ⑤ 写着 ⑤」这种断号。
    //   ⇒ 计数器只在**真正渲染**的那个分支里才 +1 (`&&` 短路 ⇒ 不消耗编号)。
    // ⚠️ v0.18.93 — 编号**改用半角数字** (`'1'`…`'5'`), 不再用带圈字符 (`'①'`…`'⑤'`)。
    //   理由: 辉哥反馈「转学员办卡 modal 里的 1、2、3 这些标记点样式与『约课』modal 不一致」。
    //   已实测定位: 两边 DOM 结构 / class / CSS **完全相同** (都走 `less/forum.less`
    //   `.ZS-followup-form .ZS-section-head .n` = 19×19 蓝底方块 + 11px/700 粗体),
    //   差异**只在一个字符** ⇒ 带圈字符在 19×19 的方块里成了「自带圆圈的小数字」
    //   (文字占位宽 10.53px), 而半角数字只有 5.70~7.63px ⇒ 视觉重量差一档。
    //   ⇒ 改成半角数字, 与「约课」modal (`LessonEditorModal.js` 的 `renderSection(1/2/3, …)`)
    //     **完全一致**。
    //   ⛔ 动态分配机制 (上面的 secIdx / 短路) 一个字没动; ⛔ LESS 一个字没动;
    //   ⛔ 结果面板的 `'✓'` (成功标记, 不是分区编号) 没动。
    let secIdx = 0;
    const nextNum = () => ['1', '2', '3', '4', '5'][secIdx++];

    // ⚠️ v0.18.95 — **底部按钮区改成「跟内容一起走」** (辉哥 10/25 原话:
    //   「『转学员 办卡』modal 下方的『取消』和『确认转学员并办卡』那块区域跟其他 modal 不一样呢
    //     （**区域位置是固定的**），改成跟『新建客户跟进』modal 一样的那种」)
    //
    //   ⇒ **做法 = 把 `.Modal-footer` 挪进 `.Modal-body` 的末尾** (⛔ **不是**改 overflow):
    //     ① `.Modal-body` 仍是**唯一**的滚动容器 (v0.18.85 的 flex 布局**一个字没动**)
    //        ⇒ 内容超长时滚的仍然是 body, 底部按钮随内容一起走 ⇒ 不再是「独立固定条」。
    //     ② ⛔⛔ `.Modal-content` 的 `overflow` / `position` **一个字不许动** ——
    //        实测: `.Modal-content` 一旦当滚动容器, 它**内部** `position:fixed` 的
    //        移动端下拉抽屉会跟着它的 `scrollTop` 偏移 ⇒ 抽屉跑出屏幕外。
    //        ⇒ 滚动容器**必须继续是** `.Modal-body`。
    //   ⇒ 返回值仍是**数组**, 但只剩**一个**元素 (`.Modal-body`, 内含 footer)。
    return [m("div", {
      className: "Modal-body",
      key: "body"
    }, m("div", {
      className: "ZS-modal-form ZS-followup-form"
    }, m("div", {
      className: "ZSC-sub"
    }, "\u6765\u81EA\u9500\u552E\u8DDF\u8FDB #", f.id, " \xB7 ", this.customerName(), " \xB7 ", STAGE_LABEL[f.stage] || f.stage || '—', " \xB7", ' ', String(f.created_at || '').slice(0, 10), " ", this.salesName(), "\u5F55\u5165"), renderSection(nextNum(), '客户信息（源）', '只读 · 用于预填', [m("div", {
      className: "ZS-form-row full"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZSC-source"
    }, m("div", {
      className: "ZSC-kv"
    }, m("div", null, m("div", {
      className: "k"
    }, "\u5BA2\u6237\u540D"), m("div", {
      className: "v"
    }, this.customerName())), m("div", null, m("div", {
      className: "k"
    }, "\u624B\u673A\u53F7"), m("div", {
      className: "v"
    }, f.phone || '—')), m("div", null, m("div", {
      className: "k"
    }, "\u7ECF\u529E\u4EBA"), m("div", {
      className: "v"
    }, this.salesName(), "\uFF08\u9500\u552E\uFF09")), m("div", null, m("div", {
      className: "k"
    }, "\u6821\u533A"), m("div", {
      className: "v"
    }, this.schoolName())), m("div", null, m("div", {
      className: "k"
    }, "\u8DDF\u8FDB\u65F6\u95F4"), m("div", {
      className: "v"
    }, String(f.created_at || '').slice(0, 16).replace('T', ' '))), m("div", null, m("div", {
      className: "k"
    }, "\u6765\u6E90"), m("div", {
      className: "v"
    }, f.lead_channel_name || '—'))), m("div", {
      className: "ZSC-source-note"
    }, "\u4EE5\u4E0A\u4FE1\u606F\u6765\u81EA\u9500\u552E\u8DDF\u8FDB\u8BB0\u5F55\uFF0C\u7528\u4E8E\u9884\u586B\u4E0B\u65B9\u8868\u5355\u3002"))))], {
      conditionalCaption: true
    }), renderSection(nextNum(), '学员账号', app.translator.trans('ziven-scheduler.forum.sales.convert.sec2-caption'), [
    /* ⚠️ v0.18.87 (改 1) — 排版改成**两两同行** (辉哥 08:1x 原话:
     *   「登录名和昵称放在同一行」; 视觉基线 =「约课」modal 的两两同行规律:
     *   教室+教练 / 学员+学员卡 / 课程类型+课程分类)。
     *   改后: 第 1 行 登录名|昵称 · 第 2 行 手机号|初始密码 · 第 3 行 邮箱(通栏)。
     *   ⛔ 五个字段的**默认值 / 校验 / 提交逻辑一个字没动** —— 只是**换位置**。
     *   ⚠️ 邮箱**保持通栏**: 它右侧有 chip「自动生成 · 用于登录与通知」+ 两行说明
     *      (`ZSC-input-wrap` = input + chip 横向排) ⇒ 放半宽会把 chip 挤出去/换行错位。 */
    m("div", {
      className: "ZS-form-row ZS-form-row-pair",
      key: "r-username-nickname"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-user'), " \u767B\u5F55\u540D ", m("span", {
      className: "req"
    }, "*")), m("div", {
      className: "ZSC-input-wrap"
    }, m("input", {
      className: "ZS-form-input",
      "data-zs-field": "username",
      value: this.form.username,
      placeholder: "\u4F8B: sf123",
      oninput: e => this.onUsernameInput(e.target.value)
    }), m("span", {
      "data-zs-marker": "username"
    }, this.renderUsernameMarker())), m("div", {
      className: "ZS-tf-hint"
    }, "\u82F1\u6587 / \u6570\u5B57 / \u77ED\u6A2A\u7EBF / \u4E0B\u5212\u7EBF\uFF0C1\u201350 \u4F4D")), m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-id-badge'), " \u6635\u79F0 ", m("span", {
      className: "req"
    }, "*")), m("input", {
      className: "ZS-form-input",
      "data-zs-field": "nickname",
      value: this.form.nickname,
      oninput: e => this.setField('nickname', e.target.value)
    }), m("div", {
      className: "ZS-tf-hint"
    }, "\u9884\u586B\u81EA\u8DDF\u8FDB\u8BB0\u5F55\u91CC\u7684\u5BA2\u6237\u540D"))), m("div", {
      className: "ZS-form-row ZS-form-row-pair",
      key: "r-phone-password"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-phone'), " \u624B\u673A\u53F7 ", m("span", {
      className: "req"
    }, "*")), m("input", {
      className: "ZS-form-input",
      "data-zs-field": "phone",
      value: this.form.phone,
      placeholder: "\u4F8B: 13800138000",
      oninput: e => this.setField('phone', e.target.value)
    }), this.phoneMissing() ? m("div", {
      className: "ZS-tf-hint danger"
    }, m("i", {
      className: "fas fa-circle-exclamation"
    }), app.translator.trans('ziven-scheduler.forum.sales.convert.err-phone-required')) : m("div", {
      className: "ZS-tf-hint"
    }, app.translator.trans('ziven-scheduler.forum.sales.convert.hint-phone'))), m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-key'), ' ', app.translator.trans('ziven-scheduler.forum.sales.convert.label-password')), m("div", {
      className: "ZSC-input-wrap"
    }, m("input", {
      className: "ZS-form-input",
      "data-zs-field": "password",
      type: this.showPassword ? 'text' : 'password',
      value: this.form.password,
      disabled: this.usernameTaken,
      oninput: e => this.setField('password', e.target.value)
    }), m("button", {
      type: "button",
      className: "ZSC-chip",
      onclick: () => {
        this.showPassword = !this.showPassword;
        m.redraw();
      }
    }, m("i", {
      className: 'fas ' + (this.showPassword ? 'fa-eye-slash' : 'fa-eye')
    }), this.showPassword ? app.translator.trans('ziven-scheduler.forum.sales.convert.password-hide') : app.translator.trans('ziven-scheduler.forum.sales.convert.password-show'))), this.usernameTaken ? m("div", {
      className: "ZS-tf-hint danger"
    }, m("i", {
      className: "fas fa-circle-exclamation"
    }), app.translator.trans('ziven-scheduler.forum.sales.convert.password-reuse-hint')) : m("div", {
      className: "ZS-tf-hint"
    }, app.translator.trans('ziven-scheduler.forum.sales.convert.password-help')))), /* 邮箱 (通栏): 批 3 加的 chip / 说明, ⛔ 原文案不许改 */
    m("div", {
      className: "ZS-form-row full",
      key: "r-email"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-envelope'), " \u90AE\u7BB1 ", m("span", {
      className: "req"
    }, "*")), m("div", {
      className: "ZSC-input-wrap"
    }, m("input", {
      className: "ZS-form-input",
      "data-zs-field": "email",
      value: this.form.email,
      oninput: e => this.setField('email', e.target.value)
    }), m("span", {
      className: "ZSC-chip warn"
    }, app.translator.trans('ziven-scheduler.forum.sales.convert.email-chip'))), m("div", {
      className: "ZS-tf-hint"
    }, app.translator.trans('ziven-scheduler.forum.sales.convert.email-help'))))], {
      conditionalCaption: true
    }), renderSection(nextNum(), '学员卡', app.translator.trans('ziven-scheduler.forum.sales.convert.sec3-caption'), [
    /* 卡种 + 校区 (同一行 2 栏) —— v0.18.94 (改 1) 按**设计稿**定稿:
     *   改版前是「卡种 (通栏)」+「校区 | 激活 (同行 2 栏)」。
     *   「激活」被搬到「经办人」下方改叫「开卡」后, 校区那一行的右半格空出来
     *   ⇒ 把校区提到**跟卡种同一行**, 右半格给校区, 左半格给卡种
     *   ⇒ 与设计稿 (`ziven-scheduler-convert-open-card-design.html`) 逐字一致。
     *   ⚠️ `.ZS-followup-form .ZS-form-row` 默认就是 **1fr 1fr** 两列
     *      (桌面端) ⇒ 只需**去掉** `full` 即成 2 栏, ⛔ 不必新增任何 CSS。
     *   ⚠️ 窄屏 (≤767px) v0.18.85 段把 `.ZS-form-row` 降级成**单列**
     *      ⇒ 手机上卡种与校区仍各占一整行 (纵向排), ⛔ 不会挤成半宽。
     *   ⚠️ 校区**不许删** (它是只读信息: 由当前校区锁定)。 */
    m("div", {
      className: "ZS-form-row"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-id-card'), " \u5361\u79CD ", m("span", {
      className: "req"
    }, "*")), this.loading ? m("div", {
      className: "ZS-form-input"
    }, "\u52A0\u8F7D\u4E2D\u2026") : m("div", {
      "data-zs-field": "template"
    }, this.renderTemplateDropdown())), m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-school'), " \u6821\u533A"), m("div", {
      className: "ZSC-input-wrap"
    }, m("input", {
      className: "ZS-form-input",
      "data-zs-field": "school",
      value: this.schoolName(),
      readonly: true
    }), m("span", {
      className: "ZSC-chip"
    }, "\u5F53\u524D\u6821\u533A")), m("div", {
      className: "ZS-tf-hint"
    }, "\u7531\u5F53\u524D\u6821\u533A\u9501\u5B9A\uFF0C\u4E0D\u53EF\u66F4\u6539"))), /* 经办人 (通栏): 本仓已有的「可搜索用户单选」组件 */
    m("div", {
      className: "ZS-form-row full"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-user-tie'), " \u7ECF\u529E\u4EBA ", m("span", {
      className: "req"
    }, "*")), this.picker.render('agent_id'), this.agentMissing && m("div", {
      className: "ZSC-branch warn"
    }, m("i", {
      className: "fas fa-circle-exclamation"
    }), m("div", null, app.translator.trans('ziven-scheduler.forum.sales.convert.agent-missing'))), !this.agentMissing && m("div", {
      className: "ZS-tf-hint"
    }, "\u4E1A\u7EE9\u5F52\u5C5E\uFF0C\u9ED8\u8BA4\u53D6\u8DDF\u8FDB\u8BB0\u5F55\u7684\u7ECF\u529E\u4EBA"))),
    /* v0.18.94 (改 1~5, 辉哥 10/25 14:36 拍板) — 「开卡」块 (**通栏, 在「经办人」之后**)
     *
     * ⛔ **样式一个字不许新写**: `.ZS-activate-row` / `.ZS-Switch` / `.ZS-Switch-slider` /
     *    `.ZS-expire-section` / `.ZS-expire-hint` 全是 `less/forum.less` 里**绑卡 modal 用的现成类**
     *    ⇒ 用对 class 名就有一样的样式 (绿色开关 = `--zs-success-10b981` = `#10b981`)。
     * ⛔ **图标不用** `fa-power-off` (那是改版前「激活」用的) ⇒ 改成绑卡 modal 同款 `fa-ticket`。
     * ⚠️ 蓝灰的 `.ZSC-switch` (老「激活」开关) 已随改 1 一起删掉。 */
    m("div", {
      className: "ZS-form-row full"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: 'ZS-activate-row ' + (this.form.is_activated ? 'on' : '')
    }, m("div", {
      className: "ZS-activate-info"
    }, m("div", {
      className: "ZS-activate-title"
    }, m("i", {
      className: "fas fa-ticket",
      style: "color:var(--zs-cyan-06b6d4, #06b6d4);margin-right:6px;"
    }), "\u5F00\u5361")), m("label", {
      className: "ZS-Switch"
    }, m("input", {
      type: "checkbox",
      checked: !!this.form.is_activated,
      onchange: e => this.setActivated(e.target.checked)
    }), m("span", {
      className: "ZS-Switch-slider"
    }))), this.form.is_activated && m("div", {
      className: "ZS-expire-section"
    }, m("div", {
      className: "ZS-form-label",
      style: "margin-bottom:10px;"
    }, m("span", null, m("i", {
      className: "fas fa-calendar-days",
      style: "color:var(--zs-warning-f59e0b, #f59e0b);margin-right:6px;"
    }), "\u8FC7\u671F\u65F6\u95F4", m("span", {
      className: "req"
    }, "*"))), m("input", {
      className: "ZS-form-input ZS-flatpickr-input",
      "data-zs-field": "expires_at",
      type: "text",
      readonly: true,
      value: this.form.expires_at || '',
      placeholder: "\u9009\u62E9\u8FC7\u671F\u65E5\u671F"
    }), this.form.expires_at && m("div", {
      className: "ZS-expire-hint ok"
    }, m("i", {
      className: "fas fa-check",
      style: "color:var(--zs-success-10b981, #10b981);margin-right:6px;"
    }), "\u5F00\u5361\u65F6\u95F4\u5C06\u8BB0\u5F55\u4E3A: ", m("strong", null, this.form.activated_at || nowFormatted())))))], {
      conditionalCaption: true
    }), cards.length > 0 && renderSection(nextNum(), '体验卡处理', null, [/* 每一张体验卡一行 */
    ...cards.map(c => {
      const consumed = c.branch === 'consumed';
      return m("div", {
        className: "ZS-form-row full",
        key: 'trial-' + c.id
      }, m("div", {
        className: 'ZSC-branch ' + (consumed ? 'warn' : 'ok')
      }, m("i", {
        className: consumed ? 'fas fa-circle-exclamation' : 'fas fa-circle-check'
      }), m("div", null, m("div", {
        className: "ZSC-tcard-top"
      }, m("b", null, c.name), m("span", {
        className: "ZSC-tcard-id"
      }, "#", c.id), m("span", {
        className: 'ZSC-chip ' + (consumed ? 'warn' : 'ok')
      }, consumed ? '已消课 · 已归属该学员' : '未体验 · 将绑定给新学员'), m("span", {
        className: "ZSC-tcard-meta"
      }, consumed ? `已消课 ${c.completed_lessons} 次` : `剩余 ${c.remaining_lessons} 次`)), consumed ? '转学员后该体验卡归属该学员，记录保留在其名下。' : `将直接绑定给新学员（剩余 ${c.remaining_lessons} 次），上课可直接使用。`, m("span", {
        className: "sub"
      }, consumed ? '体验卡是否“已消课”看的是这节课的状态，不是卡的状态。' : '卡的激活状态保持不变，不做额外改动。'))));
    }),
    // 末尾汇总句 (数字用 <b> ⇒ tabular-nums, 对齐更好读)
    m("div", {
      className: "ZS-form-row full",
      key: "trial-sum"
    }, m("div", {
      className: "ZSC-trial-sum"
    }, m("i", {
      className: "fas fa-check"
    }), m("span", null, "\u672C\u6B21\u8F6C\u5B66\u5458\u5C06\u7ED1\u5B9A ", m("b", null, counts.total), " \u5F20\u4F53\u9A8C\u5361\uFF08", m("b", null, counts.unused), " \u5F20\u672A\u4F53\u9A8C\u53EF\u76F4\u63A5\u4F7F\u7528\uFF0C", m("b", null, counts.consumed), " \u5F20\u5DF2\u6D88\u8BFE\uFF09\u3002")))], {
      conditionalCaption: true,
      extra: /* 标题行右侧的「共 N 张」计数 chip (⛔ 窄屏 `.c` 是 display:none, 不能塞进 `.c` 里) */
      m("span", {
        className: "ZSC-chip ZSC-trial-count"
      }, "\u5171 ", counts.total, " \u5F20")
    }), renderSection(nextNum(), '本次操作', null, [m("div", {
      className: "ZS-form-row full",
      key: "ops"
    }, m("div", {
      className: "ZSC-summary"
    }, "\u672C\u6B21\u8F6C\u5B66\u5458\u5C06\u540C\u65F6\u5B8C\u6210\uFF1A", m("div", {
      className: "row"
    }, m("span", null, m("i", {
      className: "fas fa-check"
    }), "\u65B0\u5EFA\u5B66\u5458\u8D26\u53F7\u5E76\u52A0\u5165\u5B66\u5458\u7EC4"), m("span", null, m("i", {
      className: "fas fa-check"
    }), "\u7ED1\u5B9A\u6821\u533A"), m("span", null, m("i", {
      className: "fas fa-check"
    }), "\u53D1\u653E\u5B66\u5458\u5361"), m("span", null, m("i", {
      className: "fas fa-check"
    }), "\u8DDF\u8FDB\u8BB0\u5F55\u5173\u8054\u5230\u8BE5\u5B66\u5458"))))], {
      conditionalCaption: true
    }), this.loading && m("div", {
      className: "ZS-tf-hint"
    }, "\u52A0\u8F7D\u4E2D\u2026"), !this.loading && !this.templates.length && m("div", {
      className: "ZSC-branch warn"
    }, m("i", {
      className: "fas fa-circle-exclamation"
    }), m("div", null, m("b", null, "\u5F53\u524D\u6821\u533A\u6CA1\u6709\u53EF\u7528\u7684\u5361\u79CD"), "\u8BF7\u5148\u5230\u300C\u5361\u7247\u7BA1\u7406\u300D\u91CC\u6DFB\u52A0\u4E00\u4E2A\u5361\u79CD, \u518D\u56DE\u6765\u8F6C\u5B66\u5458\u3002")), this.error && m("div", {
      className: "ZSC-branch warn"
    }, m("i", {
      className: "fas fa-circle-exclamation"
    }), m("div", null, this.error))), m("div", {
      className: "Modal-footer"
    }, m(Button, {
      className: "Button Button--secondary",
      onclick: () => this.hide()
    }, "\u53D6\u6D88"), m(Button, {
      className: "Button Button--primary ZSC-submit",
      disabled: !this.canSubmit(),
      loading: this.saving,
      onclick: () => this.submit()
    }, m("i", {
      className: "fas fa-user-plus"
    }), "\u786E\u8BA4\u8F6C\u5B66\u5458\u5E76\u529E\u5361")))];
  }

  /**
   * v0.18.85 (改 7) — 提交成功后的**结果提示**
   *
   * ## 为什么不是 alert / 不是 toast
   *   员工要**当面**把「登录名 + 初始密码」念给客户 ⇒ 这两行字必须**停在屏幕上**
   *   让他抄/念, ⛔ 不能一闪而过 (toast) 也不能塞进一个需要再点一次的弹窗 (alert)。
   *   ⇒ 直接把弹层内容换成结果面板, 底部按钮变成「完成并关闭」。
   *
   * ## ⛔ 只显示一次 + ⛔ 不持久化
   *   `this.result` 是**实例字段** (内存), ⛔ 不写 localStorage / sessionStorage
   *   ⇒ 刷新页面就没了 (验收口径: 「刷新页面后不再显示」)。
   */
  renderResult() {
    const r = this.result;
    // ⚠️ v0.18.95 — 同 `content()`: 底部按钮区**挪进 `.Modal-body` 的末尾** ⇒ 跟内容一起走
    //   (⛔ `.Modal-content` 的 `overflow` / `position` 一个字没动 ⇒ 滚动容器仍是 `.Modal-body`)。
    return [m("div", {
      className: "Modal-body",
      key: "rbody"
    }, m("div", {
      className: "ZS-modal-form ZS-followup-form"
    }, renderSection('✓', app.translator.trans('ziven-scheduler.forum.sales.convert.success-title'), app.translator.trans('ziven-scheduler.forum.sales.convert.success-caption'), [m("div", {
      className: "ZS-form-row full"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-user'), " \u767B\u5F55\u540D"), m("div", {
      className: "ZS-form-input ZS-cu-secret"
    }, r.username))), m("div", {
      className: "ZS-form-row full"
    }, m("div", {
      className: "ZS-form-group"
    }, m("div", {
      className: "ZS-form-label"
    }, fieldIcon('fa-key'), ' ', app.translator.trans('ziven-scheduler.forum.sales.convert.label-password')), r.reused ? m("div", {
      className: "ZS-form-input"
    }, app.translator.trans('ziven-scheduler.forum.sales.convert.success-reused')) : m("div", {
      className: "ZS-form-input ZS-cu-secret"
    }, r.password)))], {
      conditionalCaption: true
    })), m("div", {
      className: "Modal-footer"
    }, m(Button, {
      className: "Button Button--primary ZSC-submit",
      onclick: () => this.hide()
    }, app.translator.trans('ziven-scheduler.forum.sales.convert.success-done'))))];
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/modal/ConvertStudentModal', ConvertStudentModal);